import { Tooltip } from "antd";
import styles from "./style.module.less";

export const PlannedDot = () => {
    return (
        <div className={styles.plannedDot}>
            <Tooltip placement="top" title="Planned">
                <i className="ri-record-circle-line"></i>
            </Tooltip>
        </div>
    );
}